import { useMemo } from 'react'
import { useGetAssignmentRating } from 'dataQueries'
import { StarRatingEntry, mapRatingResponseToEntries } from 'models/assignment'

/**
 * Fetches and maps star rating entries for an assignment.
 */
export function useStarRatingEntries(assignmentId: string | undefined) {
  const assignmentRatingQuery = useGetAssignmentRating(assignmentId, !!assignmentId)

  const ratings = useMemo<StarRatingEntry[] | undefined>(() => {
    const data = assignmentRatingQuery.data?.data
    if (!data?.ratings?.length) return undefined
    const mapped = mapRatingResponseToEntries(data.ratings, data.isFavouriteCTForAssignment)
    return mapped.length ? mapped : undefined
  }, [assignmentRatingQuery.data])

  // Surface the favourite flag independently — BE can return isFavouriteCT=true
  // even when there is no CREATIVE rating entry yet (QA-220).
  const isFavouriteCT = assignmentRatingQuery.data?.data?.isFavouriteCTForAssignment ?? undefined

  return {
    ratings,
    isFavouriteCT,
    isLoading: assignmentRatingQuery.isLoading,
  }
}
